import { ContextMenuItems } from 'enums/app'
import { useCallback, useMemo } from 'react'
import { useDeleteChatMessageMutation } from '@crew/apis/chat/chatApis'
import { useTranslation } from '@crew/modules/i18n'

export const useAiAssistantMessageActionMenu = (
  enabledActionMenus: ContextMenuItems[]
) => {
  const { t } = useTranslation()

  const [deleteChatMessageMutation, { isLoading: isLoadingDeleteChatMessage }] =
    useDeleteChatMessageMutation()

  const contextMenuData = useMemo(() => {
    return Object.values(ContextMenuItems)
      .filter((item) => {
        // パラメータで渡されたアクションメニューのみ表示する
        return enabledActionMenus.includes(item)
      })
      .map((item) => {
        return {
          id: item.action,
          name: t(item.label),
        }
      })
  }, [enabledActionMenus, t])

  // 削除確認ダイアログ OKボタン
  const deleteChatMessage = useCallback(
    async (chatMessageId: string, version: number) => {
      await deleteChatMessageMutation({
        chatMessageId,
        version,
      }).unwrap()
    },
    [deleteChatMessageMutation]
  )

  return {
    contextMenuData,
    deleteChatMessage,
    isLoadingDeleteChatMessage,
  }
}
